import styled from 'styled-components'

export const Container = styled.div`
  > p {
    margin: 0;
  }

  p.cart__heading {
    background: none;
    border-bottom: 1px solid ${props => props.theme.palette.general.grey};
  }
`
